import { useTranslation } from "react-i18next";
import { ContentHeader, MainContentArea } from "melco-ui";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import { MachineGroupsForm } from "../../components/reporting/machineGroups/MachineGroupsForm";
import { AddGroupButton } from "../../components/reporting/machineStatus/AddGroupButton";

export const MachineGroups: React.FC = () => {
  const { t } = useTranslation();

  const breadcrumb = useBreadcrumb("reporting");
  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("reporting.machinegroups.title")}
          breadcrumb={breadcrumb}
          extra={
            <>
              <AddGroupButton />
            </>
          }
        />
      }
    >
      <MachineGroupsForm />
    </MainContentArea>
  );
};
